import PropertyListingAdapter from '../PropertyListing/adapter';
export const adapterMap = {
  propertyListing: PropertyListingAdapter
};